import React from 'react';
import { View } from 'react-native';
import { Text } from '@shared/components/text';
import { Head } from '@shared/components/head';
import Button from '@shared/components/md-design-system/Button/Button';
import Icon from '@shared/components/md-design-system/Icon/Icon';
import { colorPalette } from '@shared/config/colorsConfig';
import { dynamicTranslations } from '@shared/utils/dynamicTranslation';

interface Props {
    onGoBack: () => void;
}

const SuccessView: React.FC<Props> = ({ onGoBack }) => {
    const { t } = dynamicTranslations();
    const s = 'teleassistance.form.success';

    return (
        <View className="flex-1 px-4">
            <View className="flex-1 justify-center items-center">
                <View className="w-24 h-24 rounded-full bg-success-500 justify-center items-center mb-6">
                    <Icon name="check" size={44} color={colorPalette.white} />
                </View>
                <Head type="h2" className="text-center text-gray-900 mb-3">{t(`${s}.title`)}</Head>
                <Text className="text-base text-center text-gray-600 mb-8 w-[70%]">{t(`${s}.message`)}</Text>
            </View>
            <View className="pb-6">
                <Button size='large' variant="primary" onPress={onGoBack}>{t(`${s}.backButton`)}</Button>
            </View>
        </View>
    );
};

export default SuccessView;
